export const ENDPOINTS_AIBUILDER = {
  CREATE_DATASET: "/api/datasets",
  GET_DATASET_BY_ID: (id: number) => `/api/datasets/${id}`,
  GET_DATASETS_BY_USERAPP: () => `/api/datasets/userapp`,
  UPDATE_DATASET: (id: number) => `/api/datasets/${id}`,
  DELETE_DATASET: (id: number) => `/api/datasets/${id}`,
  CREATE_LABEL: (datasetId: number) => `/api/datasets/${datasetId}/labels`,
  UPDATE_LABEL: (id: number) => `/api/dataset-labels/${id}`,
  DELETE_LABEL: (id: number) => `/api/dataset-labels/${id}`,
  CREATE_SAMPLE: (datasetId: number) => `/api/datasets/${datasetId}/samples`,
  SET_SAMPLE_EXCLUDED: (id: number) => `/api/dataset-samples/${id}/excluded`,
  DELETE_SAMPLE: (id: number) => `/api/dataset-samples/${id}`,
  CREATE_MODEL: (datasetId: number) => `/api/datasets/${datasetId}/models`,
  GET_MODELS: (datasetId: number) => `/api/datasets/${datasetId}/models`,
};
